import React, { useState } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'

import IconEnds from '../../../images/icon_ends.svg'
import {
  StyledPromo,
  StyledPromoDetails,
  StyledPromoImgWrapper,
  StyledBottomRow,
  StyledGrid,
  StyledPromotionsOuterWrapper,
  StyledEndDate,
} from './styles'
import { Button } from '../../atoms/button'
import { Tag } from '../../atoms/tag'
import { If } from '../../atoms/if'
import { InfiniteScroll } from '../../atoms/InfiniteScroll'
import { Pagination } from '../../atoms/Pagination'
import { ResponsiveImage } from '../../atoms/responsiveImage'
import { Text } from '../../atoms/text'
import useSlugs from '../../../hooks/useSlugs'
import { usePagination } from '../../../hooks/usePagination'
import useFeatures from '../../../hooks/useFeatures'
import { useTranslation } from '../../../context/translationProvider'
import { useLocation } from '@reach/router'
import { INFINITE_SCROLL_PAGE_SIZE } from '../../../utils/constants'

const DefaultPromotionsList = (props) => {
  const { translate } = useTranslation()
  const { promotions, showMore } = props
  const { length } = promotions

  const [index, setIndex] = useState(1)
  const onShowMore = () => setIndex(index + 1)
  const maxLength = showMore ? 9 * index : length

  if (length === 0) return <></>

  return (
    <StyledPromotionsOuterWrapper>
      {renderPromotions(promotions.slice(0, maxLength))}
      <If
        condition={showMore && maxLength < length}
        render={() => (
          <Button bordered onClick={onShowMore}>
            {translate('common.showMore')}
          </Button>
        )}
      />
    </StyledPromotionsOuterWrapper>
  )
}

const InfiniteScrollPromotionsList = ({ promotions }) => {
  const { pathname } = useLocation()
  const { list, isLastPage, selectPage, nextPage, page } = usePagination({
    items: promotions,
    pathname,
  })

  return (
    <InfiniteScroll
      currentPage={page}
      loadNextPage={nextPage}
      isLastPage={isLastPage}
    >
      {renderPromotions(list)}
      <Pagination
        onPageChange={selectPage}
        pageRangeDisplayed={5}
        pageCount={promotions.length / INFINITE_SCROLL_PAGE_SIZE}
        initialPage={page}
        href={pathname}
      />
    </InfiniteScroll>
  )
}

const renderPromotions = (promotions) => {
  const [promotionsSlug] = useSlugs(['promotions'])

  return (
    <StyledGrid>
      {promotions.map((promo) => {
        return (
          <StyledPromo key={promo.slug} to={`/${promotionsSlug}/${promo.slug}`}>
            <StyledPromoImgWrapper>
              <ResponsiveImage image={promo.image} preload />
            </StyledPromoImgWrapper>
            <StyledPromoDetails>
              <Text>{promo.title}</Text>
              <StyledBottomRow>
                <Tag type={promo.type} style={{ fontSize: 13 }} />
                <If
                  condition={promo.sub_type}
                  render={() => (
                    <Tag type={promo.sub_type} style={{ fontSize: 13 }} />
                  )}
                />
                <If
                  condition={promo.isOptedIn}
                  render={() => (
                    <Tag type="opted_in" style={{ fontSize: 13 }} />
                  )}
                />
                <If
                  condition={promo.activeTo}
                  render={() => (
                    <StyledEndDate>
                      <img src={IconEnds} />
                      <Text small>
                        {dayjs.unix(promo.activeTo).format('DD/MM/YYYY')}
                      </Text>
                    </StyledEndDate>
                  )}
                />
              </StyledBottomRow>
            </StyledPromoDetails>
          </StyledPromo>
        )
      })}
    </StyledGrid>
  )
}

const PromotionsList = (props) => {
  const enableInfiniteScrolling = useFeatures('promotionsInfiniteScroll')

  return (
    <If
      condition={enableInfiniteScrolling}
      render={() => (
        <InfiniteScrollPromotionsList promotions={props.promotions} />
      )}
      renderElse={() => <DefaultPromotionsList {...props} />}
    />
  )
}

const propTypes = {
  promotions: PropTypes.array,
  showMore: PropTypes.bool,
}

PromotionsList.defaultProps = {
  promotions: [],
  showMore: false,
}

PromotionsList.propTypes = propTypes
DefaultPromotionsList.propTypes = propTypes
InfiniteScrollPromotionsList.propTypes = propTypes

export { PromotionsList }
